var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C7.53587 1.5 7.09075 1.68437 6.76256 2.01256C6.43437 2.34075 6.25 2.78587 6.25 3.25V5H9.75V3.25C9.75 2.78587 9.56563 2.34075 9.23744 2.01256C8.90925 1.68437 8.46413 1.5 8 1.5ZM5.25 3.25V5H3C2.44772 5 2 5.44772 2 6V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V6C14 5.44772 13.5523 5 13 5H10.75V3.25C10.75 2.52065 10.4603 1.82118 9.94454 1.30546C9.42882 0.789731 8.72935 0.5 8 0.5C7.27065 0.5 6.57118 0.789731 6.05546 1.30546C5.53973 1.82118 5.25 2.52065 5.25 3.25ZM3 6H5.75H10.25H13V13H3V6ZM8.5 9.5C8.5 9.77614 8.27614 10 8 10C7.72386 10 7.5 9.77614 7.5 9.5C7.5 9.22386 7.72386 9 8 9C8.27614 9 8.5 9.22386 8.5 9.5Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.db87b58619f15393b308b4b5d197a8ae.svg";
export { ForwardRef as ReactComponent };